"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estateTransactions = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Transactions_1 = require("@/pages/common/components/Transactions");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var mapStateToProps = function (state) { return ({
    chartTitle: state.estate.name,
    t: state.transactions.t,
    transactions: state.transactions.transactions,
    resultT: state.resultT,
    symbolHkd: state.layout.currencies.options.find(function (it) { return it.key === SfilterPriceGroup_1.SfilterCurrency.HKD; }).symbol,
    lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1,
}); };
var mapDispatchToProps = function () { return ({}); };
exports.estateTransactions = function (props) {
    if (!props.transactions || !props.transactions.length)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { id: "estate-transactions", className: "l-estate__section" },
        React.createElement("div", { className: "l-estate__history" },
            React.createElement("div", { className: "c-estate__section-title" },
                props.chartTitle,
                " - ",
                props.t.transactions),
            React.createElement(Transactions_1.Transactions, { lang: props.lang, resultT: props.resultT, symbolHkd: props.symbolHkd }))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.estateTransactions);
